// extracted by mini-css-extract-plugin
export var blue = "#51aec8";